module.exports = __webpack_public_path__ + "static/media/check_wht.c656e4f9.svg";